<template>
  <v-dialog v-model="value" :width="width" persistent autofocus>
    <v-card>
      <v-card-title primary-title class="px-2 py-1 mb-4 grey4">
        <div class="px-2">{{ $t("account_to_search") }}</div>
        <v-spacer />
        <v-btn
          class="ma-0"
          icon
          @click="$emit('input', false)"
          :focusable="false"
        >
          <v-icon>close</v-icon>
        </v-btn>
      </v-card-title>
      <v-layout row wrap class="px-4 py-3">
        <async-autocomplete
          outline
          autofocus
          queries="a2a=true"
          url="/transfers/create"
          returnObject
          item-value="id"
          v-model="customer"
          @setItem="goToProfile"
          item-text="full_name"
          :label="$t('customer')"
          placeholder="Account Name"
          class="flex xs12 right-hint"
        >
          <template v-slot:item="data">
            <v-list-tile-avatar>
              <img :src="data.item.image" />
            </v-list-tile-avatar>
            <v-list-tile-content>
              <v-list-tile-title
                v-html="data.item.full_name"
              ></v-list-tile-title>
              <v-list-tile-sub-title
                v-html="$t(data.item.type)"
              ></v-list-tile-sub-title>
            </v-list-tile-content>
          </template>
        </async-autocomplete>
        <v-flex xs12 mt-2>
          <v-btn dark raised class="mx-0" color="primary" @click="goToProfile">
            {{ $t("search") }}
          </v-btn>
        </v-flex>
      </v-layout>
    </v-card>
  </v-dialog>
</template>

<script>
import { customersMixin } from "@/mixins/index.js";

export default {
  mixins: [customersMixin],

  props: {
    value: {
      default: false,
      required: true,
    },
    width: {
      default: "1000px",
    },
  },
  data() {
    return {
      customer: {},
      customers: [],
    };
  },
  methods: {
    async goToProfile() {
      let customer = this.customer || {};
      let route = null;
      if (customer.type == "individual") route = `/individuals/${customer.id}`;
      else if (customer.type == "corporate")
        route = `/corporates/${customer.id}`;
      else if (customer.type == "system") route = `/branch-accounts`;
      else if (customer.type == "customer")
        route = `/customers/${customer.id}?type=customer`;
      else if (customer.type == "staff")
        route = `/staffs/${customer.id}?type=staff`;
      else if (customer.type == "saraf")
        route = `/sarafs/${customer.id}?type=saraf`;
      else if (customer.type == "commission")
        route = `/commissions/${customer.id}?type=commission`;
      else if (customer.type == "asset")
        route = `/assets/${customer.id}?type=asset`;
      else if (customer.type == "branch")
        route = `/branchs/${customer.id}?type=branch`;
      else if (customer.type == "bank")
        route = `/banks/${customer.id}?type=bank`;
      else if (customer.type == "shareholder")
        route = `/shareholders/${customer.id}?type=shareholder`;
      else if (customer.type == "expense")
        route = `/expenses/${customer.id}?type=expense`;
      else if (customer.type == "income")
        route = `/incomes/${customer.id}?type=income`;

      if (route) {
        this.$router.push(route);
        this.$emit("input", false);
      }
    },
  },
  created() {
    this.axios
      .get(`/transfers/create?a2a=true`)
      .then(({ data }) => {
        this.loading = false;
        this.customers = data.data ? data.data : data;
      })
      .catch(() => {
        this.loading = false;
      });
  },
};
</script>